import React from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import {
  renderErrorsByInputName,
  selectStylesDefault,
  selectStylesError,
} from '../../expedients_list_logic';
import { getLabelFromDictionary } from '../../../../../config/dictionary';
import PartiesLocalModal from '../../../details_expedient/modals/partiesLocalModal/PartiesLocalModal';
import PartsRelatedToTheExpedientTable from '../../../details_expedient/components/partsRelatedToTheExpedientTable/PartsRelatedToTheExpedientTable';

/**
 * Turnado interno de un expediente existente (CJJ-44): el mismo formulario que
 * "Mis Expedientes" usa para turnar, compartido con el turnado que se ofrece al
 * terminar la primera firma de una multifirma.
 *
 * Destinatarios: `receiverOptions` llega de getUsersToTransfer con
 * notShowUserLogged = true, es decir, sólo usuarios del mismo juzgado y sin el
 * propio usuario.
 */
const InternalTurnForm = ({
  transfer = {},
  setTransfer = () => {},
  errors = {},
  receiverOptions = [],
  partiesList = [],
  mattersList = [],
}) => {
  const hasError = (inputName) => Object.keys(errors).includes(inputName);
  const selectedMatter = mattersList.find(
    (option) => option.label === transfer.matter || option.value === transfer.matter
  );

  return (
    <Form>
      <Form.Group>
        {renderErrorsByInputName(errors, 'generalErrors')}
        <Form.Label>{getLabelFromDictionary('addExpediente', 'numberExpedient')}</Form.Label>
        <Form.Control
          disabled
          value={transfer['expedient_number'] ? transfer['expedient_number'] : ''}
          aria-label="numero de expediente"
          placeholder={`Agrega el número del ${getLabelFromDictionary('global', 'singleLowerMainName')}`}
          className={hasError('expedient_number') ? 'text-danger is-invalid' : ''}
        />
        <Form.Text className={errors['expedient_number'] ? 'd-n' : ''}>
          Ejemplo: 25/2019 (recuerda utilizar diagonal y capturar los cuatro dígitos del año)
        </Form.Text>
        {renderErrorsByInputName(errors, 'expedient_number')}
      </Form.Group>

      <Form.Group>
        <Form.Label>* Destinatario:</Form.Label>
        <Select
          options={receiverOptions}
          onChange={(selected) => setTransfer({ ...transfer, receiver_id: selected['value'] })}
          placeholder="Selecciona algún destinatario"
          styles={hasError('receiver_id') ? selectStylesError : selectStylesDefault}
          classNamePrefix="internal-turn-receiver"
        />
        <Form.Text className={errors['receiver_id'] ? 'd-n' : ''}>
          Selecciona el nombre del funcionario a quién deseas turnar el{' '}
          {getLabelFromDictionary('global', 'singleLowerMainName')}
        </Form.Text>
        {renderErrorsByInputName(errors, 'receiver_id')}
      </Form.Group>

      <PartiesLocalModal parties={partiesList} isTurnModal={true} />

      {renderErrorsByInputName(errors, 'parties_array')}

      <PartsRelatedToTheExpedientTable expedientParts={partiesList} />

      <Form.Group>
        <Form.Label>{getLabelFromDictionary('addExpediente', 'trialType')}</Form.Label>
        <Select
          isDisabled
          options={[]}
          placeholder="Selecciona el tipo de Juicio"
          value={transfer['kind_judgment'] || null}
          styles={selectStylesDefault}
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>{getLabelFromDictionary('addExpediente', 'via')}</Form.Label>
        <Select
          isDisabled
          options={[]}
          placeholder="Selecciona la vía"
          value={transfer['via'] || null}
          styles={selectStylesDefault}
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>{getLabelFromDictionary('addExpediente', 'subject')}</Form.Label>
        <Select
          isDisabled
          options={mattersList}
          placeholder=""
          value={selectedMatter || null}
          styles={selectStylesDefault}
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Observaciones:</Form.Label>
        <Form.Control
          onChange={(e) => setTransfer({ ...transfer, observation: e.target.value })}
          as="textarea"
          rows="5"
          aria-label="Observaciones"
          placeholder="Aquí puedes agregar algunas observaciones si lo deseas"
          value={transfer['observation'] || ''}
        />
        <Form.Text className={errors['observation'] ? 'd-n' : ''}>
          En caso de tener observaciones, captúralas aquí de manera clara y breve
        </Form.Text>
      </Form.Group>
    </Form>
  );
};

export default InternalTurnForm;
